/**
 * Returns the given string with its first letter capitalized.
 * Returns an empty string if no value is provided.
 */
export const capitalizeFirstLetter = (value: string | undefined): string => {
  if (!value) {
    return '';
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
};